// Scripting for sliders or carousels
(function($){

	// Apply slider class to group or gallery block
	$('.slider').each(function() {
		let $slider = $(this).hasClass('wp-block-gallery') ? $(this) : $(this).children().first();

		//Initialize slick
		$slider.slick({
			autoplay: false,
			// autoplaySpeed: 4500,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			infinite: true,
			draggable: true,
			prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous"></button>',
			nextArrow: '<button class="slick-next slick-arrow" aria-label="Next"></button>',
			pauseOnHover: false
		});
	});

	//change slides automatically and do not display any controls
	$('.auto-slider').each(function () {
		let $slider = $(this).hasClass('wp-block-gallery') ? $(this) : $(this).children().first();

		//Initialize slick
		$slider.slick({
			autoplay: true,
			fade: true,
			speed: 1000,
			cssEase: 'linear',
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			infinite: true,
			draggable: false,
			pauseOnHover: false,
			adaptiveHeight: false,
		});
	});

	//change slides automatically and do not display any controls
	$('.auto-slider-slow').each(function () {
		let $slider = $(this).hasClass('wp-block-gallery') ? $(this) : $(this).children().first();

		//Initialize slick
		$slider.slick({
			autoplay: true,
			fade: true,
			autoplaySpeed: 6000,
			speed: 2000,
			cssEase: 'linear',
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			infinite: true,
			draggable: false,
			pauseOnHover: true,
			adaptiveHeight: false,
		});
	});
})(jQuery);
